import { useEffect, useState } from 'react';

/**
 * `value`, settled for `delayMs`. The first value is returned immediately, so a
 * page's initial load is not delayed — only bursts of changes are coalesced.
 */
export function useDebouncedValue<T>(value: T, delayMs: number, isEqual: (a: T, b: T) => boolean = Object.is): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    if (isEqual(settled, value)) return;
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs, settled, isEqual]);
  return settled;
}
